module.exports = __webpack_public_path__ + "img/11.06993db1.png";